export const sameOrigin = (value: string): boolean => {
  try {
    return new URL(value).origin === window.location.origin;
  } catch {
    return false;
  }
};
